import { render, staticRenderFns } from "./PreshippingTable.vue?vue&type=template&id=29416c27"
import script from "./PreshippingTable.vue?vue&type=script&lang=js"
export * from "./PreshippingTable.vue?vue&type=script&lang=js"
import style0 from "./PreshippingTable.vue?vue&type=style&index=0&id=29416c27&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports